(function componentForm($, Adzuki, tinymce) {
	'use strict';

	var form = {
		name: 'ReportEcardStatistics',
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function onFormLoad()
	{
		var $modal  = $("#ecard-preview.modal"),
		    $iframe = $modal.find('iframe');

		$('.show-more-ecard-emails').click(function onShowMoreEmailsClick(e)
		{
			var $target = $(e.currentTarget);

			e.preventDefault();

			$target.parent().find('.additional_emails').toggleClass('hidden');
		});

		$("a.open-ecard-preview").click(function showEcardPreview(e) {
			e.preventDefault();
			$iframe.prop('src', $(this).data('ecard-url'));
			$modal.modal();
		});
	};

}(jQuery, window.Adzuki || {}, window.tinymce || {}));
